// Minimal `v-tooltip` directive: shows the value as the native browser tooltip.
// The views already use `v-tooltip`, but no directive was registered, so Vue logged
// "Failed to resolve directive: tooltip" on every render.
function setTitle (el, binding) {
  if (binding.value) {
    el.setAttribute('title', binding.value)
  } else {
    el.removeAttribute('title')
  }
}

export default {
  bind: setTitle,
  update: setTitle
}
